import { useState } from 'react';

export function useCounterActions() {
    const [actionsFinalisees, setActionsFinalisees] = useState(null);
    const [commentaire,       setCommentaire]       = useState('');

    const allAnswered = actionsFinalisees === true;

    const reset = () => {
        setActionsFinalisees(null);
        setCommentaire('');
    };

    return {
        actionsFinalisees, setActionsFinalisees,
        commentaire,       setCommentaire,
        allAnswered,
        reset,
        payload: { allActionsDone: actionsFinalisees, comment: commentaire },
    };
}
